// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1izty","content":"styles_content__UUkLg"};